import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .service('AgreementsDialogService', AgreementsDialogService);

    function AgreementsDialogService(ngDialog) {
        this.checkIsNewRule = function (dateOfRule, dateOfAccept) {
            if (
                new Date(dateOfRule).getTime() <
                new Date(dateOfAccept).getTime()
            ) {
                return false;
            } else {
                return true;
            }
        };

        this.openAgreement = function (
            template,
            controller,
            controllerAs,
            filePath
        ) {
            ngDialog.open({
                template: template,
                controller: controller,
                controllerAs: controllerAs,
                className: 'dialog-theme',
                showClose: false,
                closeByEscape: false,
                closeByNavigation: false,
                closeByDocument: false,
                data: { filePath: filePath },
            });
        };
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/auth/agreements_dialogs/agreements_dialog.service.ts